<script>
export default {
  props: {
    hotel: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hotelUrl() {
      return `${window.bookingUrl}&hotelId=${this.hotel.id}&addressInputType=hotel`;
    },
  },
  methods: {
    onHotelSelected() {
      window.location.href = this.hotelUrl;
    },
  },
};
</script>

<template>
  <div @click="onHotelSelected" class="hotel-result">
    <img :src="hotel.image_urls[0]" height="100" width="100" alt="" class="hotel-image" />
    <div class="hotel-data">
      <p class="name mb-8">{{ hotel.name }}</p>
      <p class="address">{{ hotel.address }}</p>
    </div>
    <img
      :src="require('images/icons/arrow_right_grey.svg')"
      class="arrow"
      :alt="$t('alt.clickToSelect')"
    />
  </div>
</template>
